<template>
	<div id="consumer" class="module module--consumer-highlights">
		<BgBox src="header-consumer" :opacity="Number(.3)" :alt="_translate('m.consumer.background.alt')" parallax>
			<div class="intro intro--constrained">
			<h2 v-html="_translate('m.consumer.title')"></h2>
				<p v-html="_translate('m.insights.intro')"></p>
			</div>
		</BgBox>
		<div class="module__body">
			<div class="container">
				<div class="wrapper">
					<section id="visitors">
						<div class="grid grid--paired">
							<div class="grid__item">
								<h3>{{ _translate('m.visitors.title')}}</h3>
								<p v-html="_translate('m.visitors.intro.a')"></p>
								<p v-html="_translate('m.visitors.intro.b')"></p>
							</div>
							<div class="grid__item">
								<Illustration class="centered" name="realtors-visitors" fx />
							</div>
						</div>
					</section>

					<!-- Traffic Sources -->
					<section id="trafficsources">
						<h3>{{ _translate('m.sources.section.title')}}</h3>

						<div class="grid grid--gap grid--organicsearch">
							<div class="grid__item">
								<Card>
									<template v-slot:front>
										<div class="grid grid--visitors">
											<div class="grid__item">
												<h3 v-html="_translate('m.sources.chart.title')" class="text-align-left"></h3>
												<SVGChart name="organic-search" class="large" />
											</div>
											<div class="grid__item grid__item--v-center">
												<Illustration name="traffic-sources" fx />
											</div>
										</div>
									</template>
								</Card>
                                <p v-html="_translate('m.breakdown.intro.b')"></p>
							</div>
							<div class="grid__item">
								<Card class="padding-min">
									<template v-slot:front>
										<div class="card__stat">
											<Illustration name="visitor-growth" />
											<br/>
											<p class="stat stat--stacked" v-html="_translate('m.breakdown.card.a.stat')"></p>
										</div>
										<div class="card__details">
											<p v-html="_translate('m.breakdown.card.a.text')"></p>
										</div>
									</template>
								</Card>
							</div>
						</div>
					</section>

					<!-- Visitor Breakdown -->
					<section id="visitorbreakdown">
						<h3>{{ _translate('m.breakdown.title')}}</h3>
						<div class="grid grid--gap">

							<div class="grid__item">
								<p v-html="_translate('m.breakdown.intro.a')"></p>
							</div>

						</div>
						<div class="flex--visitorbreakdown">
							<div>
								<div class="grid grid--2-1 grid--gap">
									<!-- Repeat Buyers -->
									<Card class="padding-min" flip>
										<template v-slot:front>
											<Illustration name="repeat-buyer" />
											<p class="stat stat--stacked" v-html="_translate('m.breakdown.card.b.stat')"></p>
											<p v-html="_translate('m.breakdown.card.b.text')"></p>
										</template>
										<template v-slot:rear>
											<p class="rear-details" v-html="_translate('m.breakdown.card.b.reverse')"></p>
										</template>
									</Card>

									<!-- First Time Home Buyers -->
									<Card class="padding-min" flip>
										<template v-slot:front>
											<Illustration name="first-time-buyer" />
											<p class="stat stat--stacked" v-html="_translate('m.breakdown.card.c.stat')"></p>
											<p v-html="_translate('m.breakdown.card.c.text')"></p>
										</template>
										<template v-slot:rear>
											<p class="rear-details" v-html="_translate('m.breakdown.card.c.reverse.a')"></p>
										</template>
									</Card>

									<!-- Residential Investor -->
									<Card class="padding-min">
										<template v-slot:front>
											<Illustration name="residential-investor"/>
											<p class="stat stat--stacked" v-html="_translate('m.breakdown.card.d.stat')"></p>
										</template>
									</Card>

									<!-- With Representation -->
									<Card class="padding-min v-center">
										<template v-slot:front>
											<p class="stat stat--stacked" v-html="_translate('m.breakdown.card.e.stat')"></p>
										</template>
									</Card>
								</div>
								<p class="emphasis" v-html="_translate('m.breakdown.paragraph.b')"></p>
								<p class="emphasis" v-html="_translate('m.breakdown.paragraph.c')"></p>
							</div>
							<div>
								<infoBox class="vertical">
									<template v-slot:text>
										<p class="emphasis" v-html="_translate('m.breakdown.infobox.a')"></p>
									</template>
									<template v-slot:links>

                                        <a v-bind:href="_translate('m.breakdown.link.a.url')" target="_blank">
                                            <span v-html="_translate('m.breakdown.link.a.text')"></span>
                                            <Icon icon="ArrowRight"/>
                                        </a>
                                        <a v-bind:href="_translate('m.breakdown.link.b.url')" target="_blank">
                                            <span v-html="_translate('m.breakdown.link.b.text')"></span>
                                            <Icon icon="ArrowRight"/>
                                        </a>
									</template>
								</infoBox>
							</div>
						</div>
					</section>

                    <section>
                        <InfoBox class="icon-left icon-black">
                            <template v-slot:icon>
                                <Icon icon="realtor-logo" />
                            </template>
                            <template v-slot:text>
                                <p class="emphasis" v-html="_translate('m.listingstats.paragraph.text')"></p>
                            </template>
                            <template v-slot:links>
                                <div class="app-links">
                                    <a class="app-link--apple" v-bind:href="_translate('m.listingstats.applestore.href')" style="display: inline-block; overflow: hidden; border-radius: 13px; width: 250px; height: 68px;" target="_blank"><img v-bind:alt="_translate('m.listingstats.applestore.alt')" v-bind:src="_translate('m.listingstats.applestore.src')" style="border-radius: 13px; width: 250px; height: 83px;"></a>
                                    <a class="app-link--google" v-bind:href="_translate('m.listingstats.googleplay.href')" target="_blank"><img v-bind:alt="_translate('m.listingstats.googleplay.alt')" v-bind:src="_translate('m.listingstats.googleplay.src')"/></a>
                                </div>
                            </template>
                        </InfoBox>
                    </section>

					<!-- Visitor Views -->
					<section id="visitorviews">
						<h3 v-html="_translate('m.visitorviews.title')"></h3>
						<div class="grid grid--2-2 grid--gap">
							<Card>
								<template v-slot:front>
									<Illustration name="realtor-users" />
									<p class="stat" v-html="_translate('m.visitorviews.card.a.stat')"></p>
									<p class="truncate" v-html="_translate('m.visitorviews.card.a.text')"></p>
									<p class="highlight" v-html="_translate('m.visitorviews.card.a.highlight')"></p>
								</template>
							</Card>
							<Card>
								<template v-slot:front>
									<Illustration name="visits-realtor" />
									<p class="stat" v-html="_translate('m.visitorviews.card.b.stat')"></p>
									<p class="truncate" v-html="_translate('m.visitorviews.card.b.text')"></p>
									<p class="highlight" v-html="_translate('m.visitorviews.card.b.highlight')"></p>
								</template>
							</Card>
							<Card class="v-center">
								<template v-slot:front>
									<div>
										<Illustration name="laptop" />
										<p class="stat" v-html="_translate('m.visitorviews.card.c.stat')"></p>
										<p v-html="_translate('m.visitorviews.card.c.text')"></p>
										<p class="highlight truncate" v-html="_translate('m.visitorviews.card.c.highlight')"></p>
									</div>
								</template>
							</Card>
							<Card>
								<template v-slot:front>
									<Illustration name="profile-views" />
									<p class="stat" v-html="_translate('m.visitorviews.card.d.stat')"></p>
									<p v-html="_translate('m.visitorviews.card.d.text')"></p>
									<p class="highlight" v-html="_translate('m.visitorviews.card.d.highlight')"></p>
								</template>
							</Card>
						</div>
						<infoBox>
							<template v-slot:text>
								<p class="emphasis" v-html="_translate('m.profileupdate.paragraph.text')"></p>
							</template>
							<template v-slot:links>
								<a v-bind:href="_translate('m.profileupdate.link.href')" target="_blank">
									<span v-html="_translate('m.profileupdate.link.text')"></span>
									<Icon icon="ArrowRight"/>
								</a>
							</template>
						</infoBox>
					</section>

					<!-- Visitor Leads -->
					<section id="visitorleads">
							<div class="grid grid--paired grid--paired-tighter">
							<div class="grid__item">
								<h3>{{ _translate('m.visitorleads.title')}}</h3>
								<p v-html="_translate('m.visitorleads.paragraph.a')"></p>
								<p v-html="_translate('m.visitorleads.paragraph.b')"></p>
							</div>
							<div class="grid__item">
								<Illustration class="centered" name="visitors-to-leads" fx />
							</div>
						</div>

						<div class="grid grid--3-3 grid--gap">
							<div class="card card--blue grid__item grid__item--v-center">
								<p class="large" v-html="_translate('m.visitorleads.paragraph.c')"></p>
							</div>

							<!-- Card A: Visitors -->
							<Card class="small side alignleft" flip>
								<template v-slot:front>
									<Illustration name="visits-page" />
									<div class="card__details">
										<p class="stat" v-html="_translate('m.visitorleads.card.visitors.stat')"></p>
										<p v-html="_translate('m.visitorleads.card.visitors.text')"></p>
									</div>
								</template>
								<template v-slot:rear>
									<p class="rear-details" v-html="_translate('m.visitorleads.card.visitors.rear')"></p>
								</template>
							</Card>

							<!-- Card B: Phone Calls -->
							<Card class="small side alignleft" flip>
								<template v-slot:front>
									<Illustration name="calls-realtor" />
									<div class="card__details">
										<p class="stat" v-html="_translate('m.visitorleads.card.phone.stat')"></p>
										<p v-html="_translate('m.visitorleads.card.phone.text')"></p>
									</div>
								</template>
								<template v-slot:rear>
									<p class="rear-details" v-html="_translate('m.visitorleads.card.phone.rear')"></p>
								</template>
							</Card>

							<!-- Card C: Searches -->
							<Card class="small side alignleft" flip>
								<template v-slot:front>
									<Illustration name="search-realtor" />
									<div class="card__details">
										<p class="stat" v-html="_translate('m.visitorleads.card.searches.stat')"></p>
										<p v-html="_translate('m.visitorleads.card.searches.text')"></p>
									</div>
								</template>
								<template v-slot:rear>
									<p class="rear-details" v-html="_translate('m.visitorleads.card.searches.rear')"></p>
								</template>
							</Card>

							<!-- Card F: Social Shares -->
							<Card class="small side alignleft" flip>
								<template v-slot:front>
									<Illustration name="social-shares" />
									<div class="card__details">
										<p class="stat" v-html="_translate('m.visitorleads.card.shares.stat')"></p>
										<p v-html="_translate('m.visitorleads.card.shares.text')"></p>
									</div>
								</template>
								<template v-slot:rear>
									<p class="rear-details" v-html="_translate('m.visitorleads.card.shares.rear')"></p>
								</template>
							</Card>

							<!-- Card G: Live Streams -->
							<!-- <Card class="small side alignleft">
								<template v-slot:front>
									<Illustration name="livestream" />
									<div class="card__details">
										<p v-html="_translate('m.visitorleads.card.livestream.text')"></p>
									</div>
								</template>
							</Card> -->

							<!-- Card H: Tours -->
							<Card class="small side alignleft" flip>
								<template v-slot:front>
									<Illustration name="tours" />
									<div class="card__details">
                                        <p class="stat" v-html="_translate('m.visitorleads.card.tours.stat')"></p>
										<p v-html="_translate('m.visitorleads.card.tours.text')"></p>
									</div>
								</template>
								<template v-slot:rear>
									<p class="rear-details" v-html="_translate('m.visitorleads.card.tours.rear')"></p>
								</template>
							</Card>

							<!-- Card D: Emails -->
							<Card class="small side alignleft" flip>
								<template v-slot:front>
									<Illustration name="email-realtor" />
									<div class="card__details">
										<p class="stat" v-html="_translate('m.visitorleads.card.emails.stat')"></p>
										<p v-html="_translate('m.visitorleads.card.emails.text')"></p>
									</div>
								</template>
								<template v-slot:rear>
									<p class="rear-details" v-html="_translate('m.visitorleads.card.emails.rear')"></p>
								</template>
							</Card>

							<!-- Card D: Additional Emails -->
							<Card class="small side alignleft">
								<template v-slot:front>
									<Illustration name="email-friend" />
									<div class="card__details">
										<p class="stat" v-html="_translate('m.visitorleads.card.additionalemails.stat')"></p>
										<p v-html="_translate('m.visitorleads.card.additionalemails.text')"></p>
									</div>
								</template>
							</Card>

							<!-- Card E: Offices -->
							<Card class="small side alignleft" flip>
								<template v-slot:front>
									<Illustration name="email-offices" />
									<div class="card__details">
										<p class="stat" v-html="_translate('m.visitorleads.card.office.stat')"></p>
										<p v-html="_translate('m.visitorleads.card.office.text')"></p>
									</div>
								</template>
								<template v-slot:rear>
									<p class="rear-details" v-html="_translate('m.visitorleads.card.office.rear')"></p>
								</template>
							</Card>

						</div>

							<infoBox>
								<template v-slot:text>
									<p class="emphasis" v-html="_translate('m.brokers.paragraph.text')"></p>
								</template>
								<template v-slot:links>
									<a v-bind:href="_translate('m.brokers.link.a.href')" target="_blank">
										<span v-html="_translate('m.brokers.link.a.text')"></span>
										<Icon icon="ArrowRight"/>
									</a>
									<a v-bind:href="_translate('m.brokers.link.b.href')" target="_blank">
										<span v-html="_translate('m.brokers.link.b.text')"></span>
										<Icon icon="ArrowRight"/>
									</a>
								</template>
							</infoBox>

					</section>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import BgBox from '@/components/BgBox.vue'
	import Card from '@/components/Card.vue'
	import Illustration from '@/components/Illustration.vue'
	import SVGChart from '@/components/SVGChart.vue'
	import reportNumbers from '@/content/reportNumbers.js'
	import InfoBox from '../components/InfoBox.vue'
	import Icon from '../components/Icon.vue'


	export default {

	  name: 'ConsumerHighlights',

	  components: {
	  	BgBox,
	  	Card,
	  	Illustration,
		SVGChart,
		InfoBox,
		Icon
	  },

	  data: function() {
	  	return {
	  		trafficSources: reportNumbers.trafficSources,
	  	}
	  },

		computed: {

	  	getTraficSources: function() {
	  		return this.$data.trafficSources;
	  	},
	  }

	}

</script>